import { useMemo } from 'react';

import { JsonParam, useQueryParam } from 'use-query-params';

export default function useFiltersSearchParams<T extends Record<string, unknown> = Record<string, unknown>>(ns?: string) {
  const [filters, updateFiltersQuery] = useQueryParam<T>('filters', { ...JsonParam, urlName: ns ? `${ns}Filters` : undefined });

  return useMemo(
    () => ({
      searchParams: filters,
      updateFiltersQuery,
    }),
    [filters, updateFiltersQuery],
  );
}
